import { render, staticRenderFns } from "./WineryEdit.vue?vue&type=template&id=2a3550ec&scoped=true&"
import script from "./WineryEdit.vue?vue&type=script&lang=ts&"
export * from "./WineryEdit.vue?vue&type=script&lang=ts&"
import style0 from "./WineryEdit.vue?vue&type=style&index=0&id=2a3550ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3550ec",
  null
  
)

export default component.exports